(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/RecmdContentResp', '../model/ApiDocRecmdLabelResp'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/RecmdContentResp'), require('../model/ApiDocRecmdLabelResp'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.RecommendationscontentApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.RecmdContentResp, root.SmartCsV2Sdk.ApiDocRecmdLabelResp);
  }
}(this, function(ApiClient, RecmdContentResp, ApiDocRecmdLabelResp) {
  'use strict';

  /**
   * Recommendationscontent service.
   * @module api/RecommendationscontentApi
   * @version 2.0.624
   */

  /**
   * Constructs a new RecommendationscontentApi. 
   * @alias module:api/RecommendationscontentApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getContent operation.
     * @callback module:api/RecommendationscontentApi~getContentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecmdContentResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve recommended content previews
     * @param {module:model/String} queryType 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.limit 
     * @param {String} opts.nextPageToken Token for retrieving next batch of data
     * @param {Integer} opts.offset &lt;font color=\&quot;FF0000\&quot;&gt;[DEPRECATED] Please plan to migrate to use nextPageToken.&lt;/font&gt; Number of items to skip.
     * @param {module:model/String} opts.sortBy 
     * @param {module:model/String} opts.category 
     * @param {module:model/String} opts.resourceType &lt;font color=\&quot;FF0000\&quot;&gt;[DEPRECATED] Please migrate to use resourceTypes.&lt;/font&gt;
     * @param {Array.<String>} opts.resourceTypes 
     * @param {module:api/RecommendationscontentApi~getContentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/RecmdContentResp}
     */
    this.getContent = function(queryType, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'queryType' is set
      if (queryType == undefined || queryType == null) {
        throw "Missing the required parameter 'queryType' when calling getContent";
      }


      var pathParams = {
      };
      var queryParams = {
        'limit': opts['limit'],
        'nextPageToken': opts['nextPageToken'],
        'offset': opts['offset'],
        'sortBy': opts['sortBy'],
        'queryType': queryType,
        'category': opts['category'],
        'resourceType': opts['resourceType'],
        'resourceTypes': this.apiClient.buildCollectionParam(opts['resourceTypes'], 'csv')
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = RecmdContentResp;

      return this.apiClient.callApi(
        '/recommendations/content', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecmdLabels operation.
     * @callback module:api/RecommendationscontentApi~getRecmdLabelsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocRecmdLabelResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the recommendation labels for a specific client platform
     * @param {module:model/String} platform the platform which the request is sent from
     * @param {module:api/RecommendationscontentApi~getRecmdLabelsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocRecmdLabelResp}
     */
    this.getRecmdLabels = function(platform, callback) {
      var postBody = null;

      // verify the required parameter 'platform' is set
      if (platform == undefined || platform == null) {
        throw "Missing the required parameter 'platform' when calling getRecmdLabels";
      }


      var pathParams = {
      };
      var queryParams = {
        'platform': platform
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ApiDocRecmdLabelResp;

      return this.apiClient.callApi(
        '/recommendations/content/labels', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
